export default {
    false: [
        {gtaId: 0, name: 'Бенджамин'},
        {gtaId: 1, name: 'Даниэль'},
        {gtaId: 2, name: 'Джошва'},
        {gtaId: 3, name: 'Ноа'},
        {gtaId: 4, name: 'Эндрю'},
        {gtaId: 5, name: 'Джуан'},
        {gtaId: 6, name: 'Алекс'},
        {gtaId: 7, name: 'Исаак'},
        {gtaId: 8, name: 'Иван'},
        {gtaId: 9, name: 'Итан'},
        {gtaId: 10, name: 'Винсент'},
        {gtaId: 11, name: 'Анжел'},
        {gtaId: 12, name: 'Диего'},
        {gtaId: 13, name: 'Адриан'},
        {gtaId: 14, name: 'Габриель'},
        {gtaId: 15, name: 'Майкл'},
        {gtaId: 16, name: 'Сантиаго'},
        {gtaId: 17, name: 'Кевин'},
        {gtaId: 18, name: 'Луис'},
        {gtaId: 19, name: 'Самуэль'},
        {gtaId: 20, name: 'Энтони'},        
        {gtaId: 21, name: 'Ханна'},
        {gtaId: 22, name: 'Одри'}, //Страшная шо пиздец
        {gtaId: 23, name: 'Джасмин'},
        {gtaId: 24, name: 'Джизель'}, //Тоже страху нагоняет
        {gtaId: 25, name: 'Амелия'},
        {gtaId: 26, name: 'Изабелла'},
        {gtaId: 27, name: 'Зоя'},
        {gtaId: 28, name: 'Ава'},
        {gtaId: 29, name: 'Камила'},
        {gtaId: 30, name: 'Виолетта'},
        {gtaId: 31, name: 'София'},
        {gtaId: 32, name: 'Эвелина'},
        {gtaId: 33, name: 'Николь'},
        {gtaId: 34, name: 'Эшли'},
        {gtaId: 35, name: 'Грейси'},
        {gtaId: 36, name: 'Брианна'},
        {gtaId: 37, name: 'Натали'},
        {gtaId: 38, name: 'Оливия'},
        {gtaId: 39, name: 'Элизабет'},
        {gtaId: 40, name: 'Шарлотта'},
        {gtaId: 41, name: 'Эмма'},        
        {gtaId: 42, name: 'Клод'},
        {gtaId: 43, name: 'Нико'},
        {gtaId: 44, name: 'Джон'},
        {gtaId: 45, name: 'Мисти'},
    ],
    true: [
        {gtaId: 0, name: 'Бенджамин'},
        {gtaId: 1, name: 'Даниэль'},
        {gtaId: 2, name: 'Джошва'},
        {gtaId: 3, name: 'Ноа'},
        {gtaId: 4, name: 'Эндрю'},
        {gtaId: 5, name: 'Джуан'},
        {gtaId: 6, name: 'Алекс'},
        {gtaId: 7, name: 'Исаак'},
        {gtaId: 8, name: 'Иван'},
        {gtaId: 9, name: 'Итан'},
        {gtaId: 10, name: 'Винсент'},
        {gtaId: 11, name: 'Анжел'},
        {gtaId: 12, name: 'Диего'},
        {gtaId: 13, name: 'Адриан'},
        {gtaId: 14, name: 'Габриель'},
        {gtaId: 15, name: 'Майкл'},
        {gtaId: 16, name: 'Сантиаго'},
        {gtaId: 17, name: 'Кевин'},
        {gtaId: 18, name: 'Луис'},
        {gtaId: 19, name: 'Самуэль'},
        {gtaId: 20, name: 'Энтони'},        
        {gtaId: 21, name: 'Ханна'},
        {gtaId: 22, name: 'Одри'}, //Страшная шо пиздец
        {gtaId: 23, name: 'Джасмин'},
        {gtaId: 24, name: 'Джизель'}, //Тоже страху нагоняет
        {gtaId: 25, name: 'Амелия'},
        {gtaId: 26, name: 'Изабелла'},
        {gtaId: 27, name: 'Зоя'},
        {gtaId: 28, name: 'Ава'},
        {gtaId: 29, name: 'Камила'},
        {gtaId: 30, name: 'Виолетта'},
        {gtaId: 31, name: 'София'},
        {gtaId: 32, name: 'Эвелина'},
        {gtaId: 33, name: 'Николь'},
        {gtaId: 34, name: 'Эшли'},
        {gtaId: 35, name: 'Грейси'},
        {gtaId: 36, name: 'Брианна'},
        {gtaId: 37, name: 'Натали'},
        {gtaId: 38, name: 'Оливия'},
        {gtaId: 39, name: 'Элизабет'},
        {gtaId: 40, name: 'Шарлотта'},
        {gtaId: 41, name: 'Эмма'},        
        {gtaId: 42, name: 'Клод'},
        {gtaId: 43, name: 'Нико'},
        {gtaId: 44, name: 'Джон'},
        {gtaId: 45, name: 'Мисти'},
    ],
}